/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [lenovoid]
 */
import { BindAll } from 'lodash-decorators';
import { BaseModel } from '../../libraries';

@BindAll()
export class AdfsController {
  readonly Model = new BaseModel({ type: 'object' });
}
